import { useEffect } from 'react';
import { UserAttributes } from '../analytics';
import { useAnalyticsContext } from './useAnalyticsContext';

export const useAnalyticsIdentify = (attributes?: UserAttributes) => {
  const { clientId, theme, identifyUser } = useAnalyticsContext();

  const identify = async () => {
    try {
      await identifyUser(attributes);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  useEffect(() => {
    if (clientId && theme) {
      identify();
    }
  }, [clientId, theme]);
};
